import { useEffect, useState } from 'react';

const HowItWorks = () => {
  const [visibleCards, setVisibleCards] = useState<number[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardIndex = parseInt(entry.target.getAttribute('data-index') || '0');
            setVisibleCards(prev => [...prev, cardIndex]);
          }
        });
      },
      { threshold: 0.15 }
    );

    const cards = document.querySelectorAll('.feature-card');
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      number: '01',
      title: 'Diagnóstico',
      description: 'Analisamos seu negócio e identificamos oportunidades de automação e IA',
    },
    {
      number: '02',
      title: 'Estratégia',
      description: 'Criamos um plano personalizado de implementação',
    },
    {
      number: '03',
      title: 'Implementação',
      description: 'Desenvolvemos, testamos e colocamos as soluções em produção',
    },
    {
      number: '04',
      title: 'Suporte',
      description: 'Acompanhamos resultados e otimizamos continuamente',
    }
  ];

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0d1117] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-1/4 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-1/4 w-96 h-96 bg-indigo-600 rounded-full blur-3xl"></div>
      </div>
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-cyan-400 uppercase tracking-wider" style={{ fontFamily: 'Inter, sans-serif' }}>Nossa Metodologia</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            Como Funciona
          </h2>
          <p className="text-xl text-slate-300 max-w-4xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            Processo estruturado da consultoria até os resultados mensuráveis
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              data-index={index}
              className={`feature-card text-center p-10 rounded-xl bg-slate-900/80 backdrop-blur-sm border border-slate-800 hover:border-cyan-500/50 hover:shadow-2xl hover:shadow-cyan-500/10 transition-all duration-500 ${
                visibleCards.includes(index) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${index * 150}ms`, fontFamily: 'Inter, sans-serif' }}
            >
              {/* Number */}
              <div className="text-6xl font-bold text-gray-500 mb-6">
                {feature.number}
              </div>

              <h3 className="text-2xl font-bold text-white mb-4">
                {feature.title}
              </h3>
              <p className="text-slate-300 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
